import './style.scss';

// ============================================================
// fadeInUp
// ============================================================
const fadeInUpObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
				fadeInUpObserver.unobserve(entry.target);
			}
		});
	},
	{ threshold: 0.1 }
);

document.querySelectorAll('.anim').forEach((el) => {
	fadeInUpObserver.observe(el);
});

// ============================================================
// ページナビ KV通過後にふわっと表示
// ============================================================
const pageNav = document.querySelector('.page-nav');
let pastKV = false;
let inFooter = false;

const updateNavVisibility = () => {
	pageNav?.classList.toggle('is-visible', pastKV && !inFooter);
};

const kvSentinel = document.querySelector('.kv-sentinel');
if (kvSentinel) {
	new IntersectionObserver(
		([entry]) => {
			// sentinelが上端より上に抜けた = KVを完全に通過した
			pastKV = !entry.isIntersecting && entry.boundingClientRect.top <= 0;
			updateNavVisibility();
		},
		{ threshold: 0 }
	).observe(kvSentinel);
}

// totop 表示制御
const totopEl = document.querySelector('.ft__totop');
const totopTrigger = document.querySelector('#totop-trigger');
if (totopTrigger && totopEl) {
	new IntersectionObserver(
		([entry]) => { totopEl.classList.toggle('is-visible', entry.isIntersecting || entry.boundingClientRect.top < 0); },
		{ threshold: 0 }
	).observe(totopTrigger);
	window.addEventListener('load', () => { totopEl.classList.add('ft__totop--ready'); });
}

const ft = document.querySelector('.ft');
if (ft) {
	new IntersectionObserver(
		([entry]) => { inFooter = entry.isIntersecting; updateNavVisibility(); },
		{ threshold: 0 }
	).observe(ft);
}

// ============================================================
// ページナビ アクティブ切り替え
// ============================================================
const navBtns = {
	'style1': document.querySelector('.page-nav__btn[href="#style1"]'),
	'style2': document.querySelector('.page-nav__btn[href="#style2"]'),
};

const sectionObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			const key = entry.target.dataset.navTarget;
			const btn = navBtns[key];
			if (btn) btn.classList.toggle('is-active', entry.isIntersecting);
		});
	},
	{ threshold: 0 }
);

// アクティブ検知は大きな style1/style2 div で行う
document.querySelectorAll('.style1, .style2').forEach((el) => {
	el.dataset.navTarget = el.classList.contains('style1') ? 'style1' : 'style2';
	sectionObserver.observe(el);
});

// ============================================================
// スムーススクロール共通（easeInOut + rAF）
// ============================================================
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const scrollDuration = 600;

const smoothScrollTo = (targetEl) => {
	if (!targetEl) return;
	const startY = window.scrollY;
	const targetY = startY + targetEl.getBoundingClientRect().top;
	const distance = targetY - startY;
	const startTime = performance.now();

	const loop = (now) => {
		const t = Math.min((now - startTime) / scrollDuration, 1);
		window.scrollTo(0, startY + distance * easeInOut(t));
		if (t < 1) requestAnimationFrame(loop);
	};
	requestAnimationFrame(loop);
};

document.querySelectorAll('.anchor').forEach((el) => {
	el.addEventListener('click', (e) => {
		const href = el.getAttribute('href');
		if (!href || !href.startsWith('#')) return;
		e.preventDefault();
		smoothScrollTo(document.querySelector(href));
	});
});

// ============================================================
// Swiper（未使用 — 必要時コメントアウト解除）
// ============================================================
/*
import Swiper from 'swiper';

const swiper = new Swiper('.swiper-container', {
	loop: true,
	autoplay: { delay: 4000, disableOnInteraction: false },
	slidesPerView: 1,
	spaceBetween: 0,
});
*/

// ============================================================
// 横スクロール（未使用 — 必要時コメントアウト解除）
// ============================================================
/*
const scrollArea = document.querySelector('.scroll-area');
if (scrollArea) {
	scrollArea.addEventListener('wheel', (e) => {
		e.preventDefault();
		scrollArea.scrollLeft += e.deltaY;
	}, { passive: false });
}
*/
